"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const RapidosAdminTable_1 = __importDefault(require("./Tables/RapidosAdminTable"));
require("./RapidosAdmin.css");
const io_1 = require("react-icons/io");
const RapidosAdmin = () => {
    const [search, setSearch] = (0, react_1.useState)("");
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Rapidos"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Rapidos"))),
                        react_1.default.createElement("div", { className: "row mb-4" },
                            react_1.default.createElement("div", { className: "col-lg-12" },
                                react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
                                    react_1.default.createElement("div", { className: "search-form-group position-relative" },
                                        react_1.default.createElement("span", { className: "search-input-icon" },
                                            react_1.default.createElement(io_1.IoMdSearch, null)),
                                        react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "RechercheRapidos", placeholder: "Rechercher par num\u00E9ro ou nom de carte...", value: search, onChange: (e) => setSearch(e.target.value) }))),
                                react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                                    react_1.default.createElement(RapidosAdminTable_1.default, { search: search }))))))))));
};
exports.default = RapidosAdmin;
